module.exports = __webpack_public_path__ + "img/exhaustPipe-1.9d3d7862.jpg";